'use client';

import { SCORE_COLORS } from '@/lib/constants';

interface ScoreBadgeProps {
  score: number;
}

export function ScoreBadge({ score }: ScoreBadgeProps) {
  const rounded = Math.round(score);
  const clamped = Math.max(1, Math.min(5, rounded));
  const colorClass = SCORE_COLORS[clamped] || SCORE_COLORS[3];

  return (
    <span
      className={`inline-flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold ${colorClass}`}
    >
      {clamped}
    </span>
  );
}
